import {createSvgIcon} from '../create-svg-icon';

export const ChevronUpIcon = createSvgIcon(
  <path d="M7 14l5-5 5 5z" />,
  'ChevronUp'
);